module.exports = __webpack_public_path__ + "static/img/bolan_t.0fed3ee4.png";